import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../Logo/Logo';
import { CountrySelector } from '../CountrySelector/CountrySelector';
// import { Search } from "../Search/Search";
import './header.css';
import { companyObject, productsObject, resourcesObject } from './assets';
import { Button } from '../buttons/Button/Button';
import { ROUTES } from 'constants/routes';

const Header = () => {
    const navigate = useNavigate();
    const height = useRef(null);
    const dropdown = useRef(null);
    const headerHeight = height.current?.clientHeight;

    useEffect(() => {
        dropdown.current.style.height = headerHeight;
    }, [headerHeight]);

    const [hoveredElement, setHoveredElement] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeMenuDropdown, setActiveMenuDropdown] = useState(null);
    const [mobileMenu, setMobileMenu] = useState(false);

    const handleMouseEnter = element => {
        !mobileMenu && setActiveMenu(element);
        !mobileMenu && setHoveredElement(element);
    };

    const handleMouseLeave = () => {
        !mobileMenu && setHoveredElement(null);
    };

    const handleMouseEnterDropdown = () => {
        setActiveMenuDropdown(activeMenu);
    };

    const handleMouseLeaveDropdown = () => {
        setActiveMenuDropdown(null);
    };

    const onMobileMenu = () => {
        console.log('mobileMenu', mobileMenu)
        setMobileMenu(!mobileMenu);
    };

    const onOpenMenu = element => {
        mobileMenu && setHoveredElement(element);
        setActiveMenu(element);

        element === hoveredElement && setHoveredElement(null);
    };

    const onOpenMobileMenu = element => {
        setActiveMenu(element);
        activeMenu === element && setActiveMenu(null);
    };

    const onOpenItem = link => {
        navigate(link);
        mobileMenu && setMobileMenu(false);
    };

    let arrayMenu = [];

    switch (activeMenu) {
        case 'company':
            arrayMenu = companyObject;
            break;
        case 'products':
            arrayMenu = productsObject;
            break;
        case 'resources':
            arrayMenu = resourcesObject;
            break;
        default:
            arrayMenu = [];
    }

    return (
        <header>
            <div className="header">
                <div className="left-section">
                    <Logo />
                    <nav className={`${mobileMenu && 'open'}`}>
                        <ul>
                            <li
                                className={`
                  ${
                      (hoveredElement && hoveredElement !== 'company') ||
                      (activeMenuDropdown && activeMenuDropdown !== 'company')
                          ? 'unactive'
                          : 'active'
                  } ${activeMenuDropdown === 'company' && 'open-menu'}
                `}
                                onMouseEnter={() => handleMouseEnter('company')}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => onOpenMenu('company')}
                            >
                                <p className="dropdown-link">COMPANY</p>
                                <div
                                    onMouseEnter={() => handleMouseEnter('company')}
                                    onMouseLeave={handleMouseLeave}
                                ></div>
                            </li>
                            <li
                                className={`
                  ${
                      (hoveredElement && hoveredElement !== 'products') ||
                      (activeMenuDropdown && activeMenuDropdown !== 'products')
                          ? 'unactive'
                          : 'active'
                  } ${activeMenuDropdown === 'products' && 'open-menu'}
                `}
                                onMouseEnter={() => handleMouseEnter('products')}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => onOpenMenu('products')}
                            >
                                <p className="dropdown-link">PRODUCTS</p>
                                <div
                                    onMouseEnter={() => handleMouseEnter('products')}
                                    onMouseLeave={handleMouseLeave}
                                ></div>
                            </li>
                            <li
                                className={`
                  ${
                      (hoveredElement && hoveredElement !== 'resources') ||
                      (activeMenuDropdown && activeMenuDropdown !== 'resources')
                          ? 'unactive'
                          : 'active'
                  } ${activeMenuDropdown === 'resources' && 'open-menu'}
                `}
                                onMouseEnter={() => handleMouseEnter('resources')}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => onOpenMenu('resources')}
                            >
                                <p className="dropdown-link">RESOURCES</p>
                                <div
                                    onMouseEnter={() => handleMouseEnter('resources')}
                                    onMouseLeave={handleMouseLeave}
                                ></div>
                            </li>
                            <li
                                className={
                                    (hoveredElement && hoveredElement !== 'contacts') ||
                                    (activeMenuDropdown && activeMenuDropdown !== 'contacts')
                                        ? 'unactive'
                                        : ''
                                }
                                onMouseEnter={() => handleMouseEnter('contacts')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <p onClick={() => onOpenItem(ROUTES.contacts)}>CONTACTS</p>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div
                    className="right-section"
                    onMouseEnter={() => mobileMenu && handleMouseEnter('changeCountry')}
                    onMouseLeave={handleMouseLeave}
                >
                    <CountrySelector />
                    {/* <Search isUnactive={hoveredElement} /> */}
                    <div className={`header-mobile ${mobileMenu && 'burger-close'}`} onClick={onMobileMenu}></div>
                </div>
            </div>
            <div
                onMouseEnter={handleMouseEnterDropdown}
                onMouseLeave={handleMouseLeaveDropdown}
                ref={dropdown}
                className="dropdown"
                style={{
                    height:
                        (hoveredElement === 'company' ||
                            hoveredElement === 'products' ||
                            hoveredElement === 'resources') &&
                        'auto',
                    padding:
                        (hoveredElement === 'company' ||
                            hoveredElement === 'products' ||
                            hoveredElement === 'resources') &&
                        '28px 24px 24px',
                }}
            >
                <div ref={height} className="dropdown-content">
                    <div className="dropdown-items-wrapper">
                        {arrayMenu?.items?.map(el => (
                            <div key={el.title} className="dropdown-item" onClick={() => onOpenItem(el.link)}>
                                <div className="images-wrapper">
                                    {el?.images?.map(item => (
                                        <img src={item} alt={item} key={item} />
                                    ))}
                                </div>
                                <div>
                                    <h4>{el.title}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                    {arrayMenu?.button && (
                        <Button href={arrayMenu?.button?.link} type="learn-more-arrow white-text">
                            {arrayMenu?.button?.name}
                        </Button>
                    )}
                </div>
            </div>
            <div className={`mobile-menu ${mobileMenu && 'opened-mobile-menu'}`}>
                {mobileMenu && (
                    <div className="mobile-navigation">
                        <ul>
                            <li>
                                <div
                                    className={`mobile-nav ${activeMenu === 'company' && 'opened'}`}
                                    onClick={() => onOpenMobileMenu('company')}
                                >
                                    <p
                                        className={`button-text ${
                                            activeMenu && activeMenu !== 'company' && 'unactive-mobile'
                                        }`}
                                    >
                                        COMPANY
                                    </p>
                                    <div></div>
                                </div>
                                <div className="mobile-nav-content">
                                    {activeMenu &&
                                        activeMenu === 'company' &&
                                        arrayMenu?.items?.map(el => (
                                            <div
                                                key={el.title}
                                                className="dropdown-item"
                                                onClick={() => onOpenItem(el.link)}
                                            >
                                                <div className="images-wrapper">
                                                    <img src={el.images[0]} alt={el.images[0]} key={el.images[0]} />
                                                </div>
                                                <div>
                                                    <h4>{el.title}</h4>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </li>
                            <li>
                                <div
                                    className={`mobile-nav ${activeMenu === 'products' && 'opened'}`}
                                    onClick={() => onOpenMobileMenu('products')}
                                >
                                    <p
                                        className={`button-text ${
                                            activeMenu && activeMenu !== 'products' && 'unactive-mobile'
                                        }`}
                                    >
                                        PRODUCTS
                                    </p>
                                    <div></div>
                                </div>
                                <div className="mobile-nav-content">
                                    {activeMenu &&
                                        activeMenu === 'products' &&
                                        arrayMenu?.items?.map(el => (
                                            <div
                                                key={el.title}
                                                className="dropdown-item"
                                                onClick={() => onOpenItem(el.link)}
                                            >
                                                <div className="images-wrapper">
                                                    <img src={el.images[0]} alt={el.images[0]} key={el.images[0]} />
                                                </div>
                                                <div>
                                                    <h4>{el.title}</h4>
                                                </div>
                                            </div>
                                        ))}
                                    {activeMenu === 'products' && arrayMenu?.button && (
                                        <Button href={arrayMenu?.button?.link} type="learn-more-arrow white-text">
                                            {arrayMenu?.button?.name}
                                        </Button>
                                    )}
                                </div>
                            </li>
                            <li>
                                <div
                                    className={`mobile-nav ${activeMenu === 'resources' && 'opened'}`}
                                    onClick={() => onOpenMobileMenu('resources')}
                                >
                                    <p
                                        className={`button-text ${
                                            activeMenu && activeMenu !== 'resources' && 'unactive-mobile'
                                        }`}
                                    >
                                        RESOURCES
                                    </p>
                                    <div></div>
                                </div>
                                <div className="mobile-nav-content">
                                    {activeMenu &&
                                        activeMenu === 'resources' &&
                                        arrayMenu?.items?.map(el => (
                                            <div
                                                key={el.title}
                                                className="dropdown-item"
                                                onClick={() => onOpenItem(el.link)}
                                            >
                                                <div className="images-wrapper">
                                                    <img src={el.images[0]} alt={el.images[0]} key={el.images[0]} />
                                                </div>
                                                <div>
                                                    <h4>{el.title}</h4>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </li>
                            <li>
                                <div className="mobile-nav">
                                    <p
                                        className={`button-text ${activeMenu && 'unactive-mobile'}`}
                                        onClick={() => onOpenItem(ROUTES.contacts)}
                                    >
                                        CONTACTS
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <div className="social-media-section">
                            <p>We're on social media</p>
                            <div className="social-media-wrapper">
                                <Button type="instagram" />
                                <Button type="facebook" />
                                <Button type="youtube" />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
